// Slice 40 — semantic status dot with optional pulse + halo.

export type HqStatusTone = "neutral" | "success" | "warn" | "danger" | "accent";

const COLOR: Record<HqStatusTone, string> = {
  neutral: "var(--hq-text-dim)",
  success: "var(--hq-success)",
  warn: "var(--hq-warn)",
  danger: "var(--hq-danger)",
  accent: "var(--hq-accent)",
};

const HALO: Record<HqStatusTone, string> = {
  neutral: "rgba(115,122,136,.13)",
  success: "rgba(52,211,153,.13)",
  warn: "rgba(251,191,36,.13)",
  danger: "rgba(251,113,133,.13)",
  accent: "rgba(34,211,238,.13)",
};

export function HqStatusDot({
  tone = "neutral",
  pulse = false,
  size = 8,
}: {
  tone?: HqStatusTone;
  pulse?: boolean;
  size?: number;
}) {
  return (
    <span
      className={pulse ? "hq-pulse-dot" : undefined}
      style={{
        display: "inline-block",
        width: size,
        height: size,
        borderRadius: 99,
        background: COLOR[tone],
        boxShadow: pulse ? `0 0 0 3px ${HALO[tone]}` : "none",
      }}
    />
  );
}
